import BaseContainer from 'app/containers/BaseContainer';
import { observer } from 'mobx-react';
import { MainMenu } from './MainMenu';
import { RouteComponentProps, useParams, useHistory, useLocation } from 'react-router-dom';
import { useStore } from 'app/context';
import { useEffect, useState } from 'react';
import { AdminImportJobsList } from 'app/components/admin/imports/AdminImportJobsList';
import { AdminImportJobDetailPanel } from 'app/components/admin/imports/AdminImportJobDetail';
import { ImportDataType } from 'app/stores/admin.imports.store';
import moment from 'moment';
import { DatenStandList } from 'app/components/DatenStandList';
import { Button } from 'app/components/common/Button';
import { EnsureAdmin } from './AdminHomeContainer';
import { notify } from 'app/components/common/notify';
import { AdminImportNewButton } from 'app/components/admin/imports/AdminImportNewButton';

export interface AdminUsersParamTypes {
	type?: string;
	id?: string;
}



const AdminImportsContainer = observer((props: RouteComponentProps) => {
	const { adminImportsUiStore, adminImportsStore } = useStore();
	const history = useHistory();
	const location = useLocation();

	const { type, id } = useParams<AdminUsersParamTypes>();

	// Get search filter from query string
	const searchParams = new URLSearchParams(location.search);

	const [showDatenStand, setShowDatenStand] = useState(searchParams.get('view') !== 'imports');
	const [searchFilter, setSearchFilter] = useState(searchParams.get('filter') || '');
	const [groupFilter, setGroupFilter] = useState<'all' | 'core' | 'project' | 'adz'>(
		(searchParams.get('group') as 'all' | 'core' | 'project' | 'adz') || 'all'
	);

	// Update URL when filter changes
	const updateSearchFilter = (newFilter: string) => {
		setSearchFilter(newFilter);
		const newSearchParams = new URLSearchParams(location.search);
		if (newFilter) {
			newSearchParams.set('filter', newFilter);
		} else {
			newSearchParams.delete('filter');
		}
		history.replace({
			pathname: location.pathname,
			search: newSearchParams.toString()
		});
	};

	const updateView = (datenStand: boolean) => {
		setShowDatenStand(datenStand);
		const newSearchParams = new URLSearchParams(location.search);
		if (datenStand) {
			newSearchParams.delete('view');
		} else {
			newSearchParams.set('view', 'imports');
		}
		history.replace({
			pathname: location.pathname,
			search: newSearchParams.toString()
		});
	};

	const updateGroupFilter = (newGroup: 'all' | 'core' | 'project' | 'adz') => {
		setGroupFilter(newGroup);
		const newSearchParams = new URLSearchParams(location.search);
		if (newGroup !== 'all') {
			newSearchParams.set('group', newGroup);
		} else {
			newSearchParams.delete('group');
		}
		history.replace({
			pathname: location.pathname,
			search: newSearchParams.toString()
		});
	};

	useEffect(() => {
		if (type === 'job') {
			adminImportsUiStore.loadById(id);
		}
		if (type === 'new') {
			adminImportsUiStore.createNewJob(id as ImportDataType);

		}
	}, [adminImportsUiStore, id, type]);

	const fixDurcheianander = () => {
		notify('gestartet. hoffentlich hilfts');
		adminImportsStore.triggerFixDurcheinander().then(() => {
			notify('fertisch');
		})

	}

	const rerunLeadNow = () => {
		notify('leadnow rerun gestartert. sollte etwas dauern.. ');
		adminImportsStore.rerunDataType(ImportDataType.leadnow).then(() => {
			notify('fertisch');
		})

	}

	const rerunLeadNowConv = () => {
		notify('leadnowconv rerun gestartert. sollte etwas dauern.. ');
		adminImportsStore.rerunDataType(ImportDataType.leadnowconv).then(() => {
			notify('fertisch');
		})

	}

	const triggerImportFitnessPdfs = () => {
		notify('gestartet');
		adminImportsStore.triggerImportFitnessPdfs().then(() => {
			notify('fertisch');
		})

	}

	const ImportNavbar = () => {
		return (
			<>
				<div className="admin-navbar">
					<div className="is-left">
						<strong>Daten Importieren</strong>
					</div>
					<div className="is-right">
						<strong>KW {moment().format("WW")}</strong>
					</div>
				</div>
			</>
		);
	};

	return (
		<BaseContainer classModifier="admin-container" sideMenu={<MainMenu {...props} />} navbar={<ImportNavbar />}>
			<EnsureAdmin />
			<Button type="button" className="button is-big" onClick={() => updateView(true)} disabled={showDatenStand}>Datenstände</Button>
			<Button type="button" className="button is-big" onClick={() => updateView(false)} disabled={!showDatenStand}>Import Historie</Button>
			&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;

			<Button type="button" className="button is-big" onClick={() => fixDurcheianander()} disabled={!showDatenStand}>Fix VTNR Durcheinander</Button>


			<Button type="button" className="button is-big" onClick={() => rerunLeadNow()} disabled={!showDatenStand}>Rerun Leadnow</Button>

			<Button type="button" className="button is-big" onClick={() => rerunLeadNowConv()} disabled={!showDatenStand}>Rerun Leadnowconv</Button>

			{/* Unified search box for both views */}
			<div style={{ marginTop: '20px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
				<input
					type="text"
					placeholder={showDatenStand ? "Search..." : "Filter by Quelle..."}
					value={searchFilter}
					onChange={(e) => updateSearchFilter(e.target.value)}
					style={{
						padding: '8px 12px',
						fontSize: '14px',
						border: '1px solid #ccc',
						borderRadius: '4px',
						width: '300px'
					}}
				/>
				{showDatenStand && (
					<select
						value={groupFilter}
						onChange={(e) => updateGroupFilter(e.target.value as 'all' | 'core' | 'project' | 'adz')}
						style={{
							padding: '8px 12px',
							fontSize: '14px',
							border: '1px solid #ccc',
							borderRadius: '4px'
						}}
					>
						<option value="all">Alle</option>
						<option value="core">Core</option>
						<option value="project">Project</option>
						<option value="adz">ADZ Relevant</option>
					</select>
				)}
				{searchFilter && (
					<button
						onClick={() => updateSearchFilter('')}
						style={{ padding: '8px 12px' }}
					>
						Clear
					</button>
				)}
			</div>

			{showDatenStand ?
				<>
					<div className="title">Aktuelle Datenstände</div>
					<DatenStandList searchFilter={searchFilter} groupFilter={groupFilter} />
				</> :
				<>
					<div className="title">Import Historie</div>
					<AdminImportJobsList searchFilter={searchFilter} />
				</>
			}
			<AdminImportJobDetailPanel />
		</BaseContainer>
	);
});

export default AdminImportsContainer;
